$(window).on('load', function() {
  "use strict";
  $('.megamenu-li').parent('.container').parent('ul').addClass('mega-menu');
  $('.banner-wrap').parent('.container').parent('ul').addClass('bottom-banner');
  $('.menu-banner').parent('.container').parent('ul').addClass('banner-menu');
  $('.submenu-li').parent('.container').parent('ul').addClass('sub-menu');

  var popup = localStorage.getItem('popup_value'); 
  if(popup != 1 && $('#news-letter-modal').length && $.fn.modal){
    $('#news-letter-modal').modal('show');
  }

  $('#popup-close').on('click',function(){
      localStorage.setItem('popup_value', '1');
  });
  $("button.navbar-toggler").on('click', function() {
    $(".main-menu-area").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
    $("body").addClass("hidden");
  });

  $(".close-box").on('click', function() {
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
  });

  $(".shopping-cart a.cart-count").on('click', function() {
    $(".mini-cart").addClass("show");
    $(".mm-fullscreen-bg").addClass("active");
  });

  $(".shopping-cart-close i").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
     $("body").removeClass("hidden");
  });

   $(".ajax-spin-cart").on('click', function() {
    window.setTimeout(function() {
      $(".mini-cart").addClass("show");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
    }, 1000);
  });

  $("button.filter-button").on('click', function() {
    $(".filter-sidebar").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
  });

  $("button.close-filter-sidebar").on('click', function() {
    $(".filter-sidebar").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
  });

  $(".mm-fullscreen-bg").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $(".filter-sidebar").removeClass("active");
    $("body").removeClass("hidden");
  });

  if ($.fn.tooltip) {
    $('[data-toggle="tooltip"]').tooltip();
  }

  if ($.fn.magnificPopup) {
    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
    tClose: 'Close (Esc)',
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
    });
  }

  $('#top').on('click', function() {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
});

/*
 * =====================================================================
 * سكرول محسَّن للأداء (يستبدل معالج $(window).scroll القديم غير المحسَّن)
 * =====================================================================
 * التغييرات:
 * 1) يقرأ scrollTop مرة واحدة فقط بدل مرتين لكل نداء
 * 2) يستخدم requestAnimationFrame بدل التنفيذ المتزامن مع كل بكسل سكرول
 *    خام، فيتوافق مع دورة رسم المتصفح بدل ما يزاحمها (هذا تحديداً هو
 *    سبب التقطّع الملحوظ أكثر على Safari بالآيفون، لأن Safari أكثر
 *    صرامة بجدولة عمل الجافاسكربت المرتبط بالسكرول)
 * 3) يبدّل كلاس is-sticky فقط عند تغيّر الحالة الفعلية (عبور حد 150px)
 *    بدل ما يعيد كتابته مع كل نداء حتى لو الحالة نفسها — هذا يلغي
 *    إعادة الرسم القسري (reflow) غير الضرورية بمعظم لحظات السكرول
 * =====================================================================
 */
(function () {

  var topBtn = document.getElementById('top');
  var stickyEl = document.querySelector('.header-area');

  var lastIsSticky = null;
  var lastShowTop = null;
  var ticking = false;

  function applyScrollState() {

    var scrollY = window.pageYOffset || document.documentElement.scrollTop;

    var showTop = scrollY > 1000;
    if (showTop !== lastShowTop) {
      if (topBtn) {
        topBtn.style.display = showTop ? '' : 'none';
      }
      lastShowTop = showTop;
    }

    var isSticky = scrollY >= 150;
    if (isSticky !== lastIsSticky) {
      if (stickyEl) {
        stickyEl.classList.toggle('is-sticky', isSticky);
      }
      lastIsSticky = isSticky;
    }

    ticking = false;
  }

  window.addEventListener('scroll', function () {

    if (!ticking) {
      window.requestAnimationFrame(applyScrollState);
      ticking = true;
    }

  }, { passive: true });

})();
